import React from 'react';
import { SEC_SUB_SUCCESS_PLACEMENT } from '@client/config/constants';
import HappyFace from '@client/components/shared/faces/HappyFace';
import SadFace from '@client/components/shared/faces/SadFace';
import NeutralFace from '@client/components/shared/faces/NeutralFace';
import { PercentageIcon } from '@client/components/shared/SvgIcons';

const STEPS = {
    INITIAL: 'initial',
    REJECTED: 'rejected',
    SUCCESS: 'success',
    ERROR: 'error'
};

const getError = ({ isCucaHelpShown, subscribe }) => ({
    id: STEPS.ERROR,
    title: 'errorHeader',
    text: isCucaHelpShown ? 'errorTextCuca' : 'errorText',
    yesMessage: isCucaHelpShown ? null : 'errorButton',
    iconComponent: <SadFace />,
    onAccept: subscribe,
});

const getSuccess = ({ isDoi, confirmEmail }) => ({
    id: STEPS.SUCCESS,
    title: 'successHeader',
    text: isDoi ? 'successTextDoiSlick' : 'successTextSlick',
    yesMessage: isDoi && confirmEmail ? 'successButtonDoi' : null,
    onAccept: isDoi && confirmEmail ? confirmEmail : null,
    placeholder: !isDoi || !confirmEmail,
    iconComponent: <HappyFace />,
});

const getRejected = ({ placement, close, subscribe }) => ({
    id: STEPS.REJECTED,
    title: 'rejectionHeaderSlick',
    text: 'rejectionTextSlick',
    yesMessage: 'rejectionButtonSlick',
    iconComponent: <NeutralFace />,
    onAccept: subscribe,
    onReject: placement !== SEC_SUB_SUCCESS_PLACEMENT ? close : null,
});

const getInitial = ({ hasOrders, subscribe, reject }) => ({
    id: STEPS.INITIAL,
    title: hasOrders ? 'messageHeaderBuyers' : 'messageHeader',
    text: 'messageTextSlick',
    iconComponent: <PercentageIcon />,
    onAccept: subscribe,
    onReject: reject,
});

export const getStep = (ownProps) => {
    const { error, rejected, accepted } = ownProps;

    if (error) {
        return getError(ownProps);
    }

    if (accepted) {
        return getSuccess(ownProps);
    }

    if (rejected) {
        return getRejected(ownProps);
    }

    return getInitial(ownProps);
};
